module.exports = __webpack_public_path__ + "static/fabric-persona-color-707926600c16e8b58127720fb9fbc34f.png";